<!--
 * @Description: 这是接收实时监控的数据并转换成需要的数据传给displayBoard.vue页面（组件）
 * @Date: 2020-07-22 18:55:28
 * @Author: 米虫
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-10-23 18:46:37
--> 
<template>
  <display-board :graph="graph" :extend="chartExtend" :data="chartData" :nodata="flag"></display-board>
</template>

<script>
import displayBoard from './displayBoard.vue';

export default {
  props: {
    graph: {
      type: Object,
      default: () => {},
    },
    realTimeData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    displayBoard,
  },
  data() {
    return {};
  },
  computed: {
    flag() {
      let flag = true;
      if (this.graph.rules.length) {
        this.graph.rules.forEach((item) => {
          if (
            this.realTimeData[item.point.name] ||
            this.realTimeData[item.point.name] === 0
          ) {
            flag = false;
          }
        });
      } else {
        flag = true;
      }
      return flag;
    },
    chartData() {
      let rows = this.graph.rules.map((item) => {
        return {
          name: item.alias || item.point.desc || item.point.name,
          value: this.realTimeData[item.point.name],
        };
      });
      let columns = ['name', 'value'];
      return {
        columns,
        rows,
      };
    },
    chartExtend() {
      return {
        series: {
          type: 'gauge',
          min: this.graph.min,
          max: this.graph.max,
          splitNumber: this.graph.splitNumber,
          axisLabel: {
            // 保留两位小数显示
            // formatter: function (value) {
            //     return value.toFixed(2);
            // },
            show: this.graph.calibrationType,
            formatter:
              this.graph.calibrationRadio === 2
                ? this.computedCalibrationValue.bind(this)
                : this.computedCalibrationValue.bind(this),
          },
          axisLine: {
            lineStyle: {
              color: this.computedColorlist(
                this.graph.splitNumber,
                this.graph.max,
                this.graph.min
              ),
            },
          },
          detail: {
            // 仪表盘详情，用于显示数据。
            show: true, // 是否显示详情,默认 true。
            offsetCenter: [0, '92%'], // 相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
            color: 'auto', // 文字的颜色,默认 auto。
            fontSize: 30, // 文字的字体大小,默认 15。
            // formatter:
            //     this.tempGraph.pointRadio === 2
            //         ? '{value}%'
            //         : '{value}', // 格式化函数或者字符串
            // formatter: '{value}', // 格式化函数或者字符串
            formatter:
              //  function (value) {
              //     return value.toFixed(2);
              // },
              this.graph.pointRadio === 2 ||
              (this.graph.rules.length && this.graph.rules[0].point.unit)
                ? this.formatterValue.bind(this)
                : this.formatterValue.bind(this),
          },
        },
        legend: {
          show: true,
          // top: 10,
          bottom: '20%',
        },
        tooltip: {
          show: true,
          formatter:
            this.graph.pointRadio === 2 ||
            (this.graph.rules.length && this.graph.rules[0].point.unit)
              ? this.formatTooltipValue.bind(this)
              : this.formatTooltipValue.bind(this),
        },
      };
    },
  },
  methods: {
    //计算仪表盘的颜色数组
    computedColorlist(number, max, min) {
      let colorList = [];
      let colors = [
        '#c23531',
        '#2f4554',
        '#61a0a8',
        '#d48265',
        '#91c7ae',
        '#749f83',
        '#ca8622',
        '#bda29a',
        '#6e7074',
        '#546570',
        '#c4ccd3',
        '#c23531',
        '#2f4554',
        '#61a0a8',
        '#d48265',
        '#91c7ae',
        '#749f83',
        '#ca8622',
        '#bda29a',
        '#6e7074',
        '#546570',
        '#c4ccd3',
      ];
      // 配了颜色，使用这个颜色数组
      if (this.graph.intervalList && this.graph.intervalList.length) {
        let list = JSON.parse(JSON.stringify(this.graph.intervalList));
        list.forEach((item, index) => {
          // 若是多个区间，下一个区间比上一个区间值大的话，下一个区间的值设为上一个区间的值
          if (
            index > 0 &&
            Number(list[index].value) < Number(list[index - 1].value)
          ) {
            item.value = Number(list[index - 1].value);
          }
          // colorList.push([
          //     Math.round((parseFloat(item.value) / 100) * 10000) /
          //         10000,
          //     item.color
          // ])
          // colorList.push([item.value / (max - min), item.color])
          // colorList.push([
          //     ((max - min) / number / (max - min)) * (index + 1),
          //     item.color
          // ])
          //百分比显示
          if (this.graph.intervalRadio === 2) {
            colorList.push([item.value / (max - min), item.color]);
          } else {
            //原始值显示
            colorList.push([(item.value - min) / (max - min), item.color]);
          }
        });
      } else {
        // 兼容之前没有配颜色的情况，使用这个颜色数组
        for (let i = 0; i <= number; i++) {
          //每个区间的长度，在乘以段数
          // colorList.push([
          //     ((max - min) / number / 100) * i,
          //     colors[i]
          // ])
          colorList.push([
            ((max - min) / number / (max - min)) * (i + 1),
            colors[i],
          ]);
        }
      }

      return colorList;
    },
    //内部刻度是百分比还是数值
    computedCalibrationValue(value) {
      if (typeof value !== 'number') {
        value = Number(value);
      }
      return this.graph.calibrationRadio == 2
        ? value.toFixed(2) + '%'
        : value.toFixed(2);
    },
    // 值显示原值还是百分比
    formatterValue(value) {
      if (typeof value !== 'number') {
        value = Number(value);
      }
      return this.graph.pointRadio == 2
        ? value.toFixed(2) + '%'
        : value.toFixed(2) +
            ((this.graph.rules.length > 0 && this.graph.rules[0].point.unit) ||
              '');
    },
    formatTooltipValue(obj) {
      if (typeof obj.value !== 'number') {
        obj.value = Number(obj.value);
      }
      return this.graph.pointRadio == 2
        ? obj.seriesName + '：' + obj.value.toFixed(2) + '%'
        : obj.seriesName +
            '：' +
            obj.value.toFixed(2) +
            ((this.graph.rules.length > 0 && this.graph.rules[0].point.unit) ||
              '');
    },
  },
};
</script>
